import React from 'react'
import { ProductItem } from '@components/common/ProductTile/ProductTilePlp'
import type { CategoryTree, Maybe, ProductInterface } from '@pylot/pylotschema'

interface WrappedProductItemProps {
    product: ProductInterface
    category?: Maybe<CategoryTree>
}

export const WrappedProductItem = ({
    product,
    category
}: WrappedProductItemProps): JSX.Element => (
    <ProductItem
        product={product}
        imageParam={{ width: 500 }}
        category={category}
    />
)
